import React from 'react';

const RecycleIcon = () => (
    <div className='RecycleIcon DesktopIcon'>
        <img
            // src='/images/RecycleIcon.png'
            src='/images/Finalized/RecycleIcon.png'
            alt='Recycle Bin'
            draggable={false}
            onDragStart={(e) => e.preventDefault()}
        />
        <span>Recycle</span>
    </div>
);

export default RecycleIcon;
